import ConfigurationService from '../Service/ConfigurationService';
import { RequestConfig, Role, Roles } from 'tree-wallet-client';
import { requestOrThrow } from '../Helper/Http';
import { getRoleFromArray, arrayHasRole } from "../Service/RoleService";
import { getToken } from '../Service/AuthService';

export const roles: Roles = {
  Agent: {
    label: 'agent',
    name: 'ROLE_AGENT'
  },
  Validator: {
    label: 'validator',
    name: 'ROLE_VALIDATOR'
  },
  Coordinator: {
    label: 'coordinator',
    name: 'ROLE_COORDINATOR'
  },
  TreePlanter: {
    label: 'planter',
    name: 'ROLE_TREE_PLANTER'
  },
  LandOwner: {
    label: 'land owner',
    name: 'ROLE_LAND_OWNER'
  },
  Customer: {
    label: 'customer',
    name: 'ROLE_CUSTOMER'
  },
};

export function getRole(targetRole: string): Role|undefined {
  return getRoleFromArray(targetRole, Object.values(roles));
}

export function hasRole(userRoles: string[]|undefined, targetRole: string): boolean {
  if (!userRoles) {
    return false;
  }
  return arrayHasRole(userRoles, targetRole);
}

export async function getContractsList(config?: RequestConfig) {
  // No token, no contracts: the API can only answer 403 "Missing token". The boot sequence asks for this
  // on every page load, which is what logged that 403 on logout - and for anonymous visitors too
  if (!getToken()) {
    return [];
  }

  const url = `${ConfigurationService.urls().contractListUrl}`;

  return await requestOrThrow(url, config || {});
}

export function getAdminContractsList(config: RequestConfig) {
  return requestOrThrow(
    `${ConfigurationService.urls().contractAdminListUrl}`,
    config || {}
  );
}

export async function getAdminContract(contractId: any, config: RequestConfig) {
  const { params } = config || {};

  if (!params && !params.contractId) {
    throw new Error('ContractRepository::getContract - missing contractId');
  }

  return await requestOrThrow(
    `${ConfigurationService.urls().getContractAdminUrl}/${contractId}`,
    config
  );
}

export async function createContract(data: FormData, config: RequestConfig) {
  return await requestOrThrow(
    `${ConfigurationService.urls().createContractUrl}`,
    { ...config, httpConfig: {
      multipart: true,
      method: 'POST',
      body: data
    } }
  );
}

export async function updateContract(data: FormData, config: RequestConfig) {
  const { params } = config || {};

  if (!params && !params.contractId) {
    throw new Error('ContractRepository::updateContract - missing contractId');
  }

  return await requestOrThrow(
    `${ConfigurationService.urls().updateContractUrl}/${params.contractId}`,
    { ...config, httpConfig: {
      multipart: true,
      method: 'POST',
      body: data
    } }
  );
}